import React, {useState} from 'react';
import {FEEDBACK, NEGATIVE_FEEDBACK_OPTIONS} from "@hasbro/tpi-data-models";
import LikeButton from "@/components/common/buttons/LikeButton";
import DislikeButton from "@/components/common/buttons/DislikeButton";

const NegativeFeedbackModal = ({feedback, onSelect}) => {
	return <div className={'absolute w-full bg-primary text-white drop-shadow-lg border-solid border-secondary border-[1px] bottom-12 left-[50%] -translate-x-[50%] p-4 rounded-lg'}>
		<div><span className={'font-gBold'}>Please, tell us more.</span> <em className={'text-sm'}>(select one)</em>
			<br /><br />This question was...
		</div>

		<div className={'p-2'}>

			{NEGATIVE_FEEDBACK_OPTIONS.map(o => <div key={o.value}>
				<label>
					<input name={'feedback'} type={'radio'} checked={o.value === feedback} value={o.value} onChange={() => onSelect(o.value)} data-testid={`feedback-${o.value}`}/>
					&nbsp;{o.label}
				</label>
			</div>)}
		</div>
	</div>
}

const Feedback = ({color='#fff', text = "Did you like this question?", feedback, onFeedback }) => {
	const [showPrompt, setShowPrompt] = useState(false)
	const [feedbackOption, setFeedbackOption] = useState(feedback)
	const onLike = () => {
		setShowPrompt(false)
		onFeedback(FEEDBACK.liked)
		setFeedbackOption(FEEDBACK.liked)
	}
	const onDislike = () => {
		// prompt negative feedback
		setShowPrompt(!showPrompt)
		// onFeedback(FEEDBACK.not_fun)
	}
	const onNegativeFeedbackSelect = (value) => {
		// prompt negative feedback
		setShowPrompt(false)
		onFeedback(value)
		setFeedbackOption(value);
	}
	return <div className={'flex gap-2 items-center relative'} style={{color}}>
		<div className={'grow gSemi text-base'}>{text}</div>
		<LikeButton selected={feedbackOption === FEEDBACK.liked} onClick={onLike} color={color} />
		<DislikeButton selected={feedbackOption && feedbackOption !== FEEDBACK.liked} onClick={onDislike} color={color} />
		{showPrompt && <NegativeFeedbackModal feedback={feedback} onSelect={onNegativeFeedbackSelect} />}
	</div>
}

export default Feedback;
